export function removeEmptyValues(obj: Record<string, any>): Record<string, any> {
    if (!obj || typeof obj !== "object") {
        return {}
    }

    return Object.fromEntries(
        Object.entries(obj).filter(([key, value]) => {
            if (key === "name") return false
            if (value === null || value === undefined || value === "") return false
            if (Array.isArray(value) && value.length === 0) return false
            return true
        })
    )
}